// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top--100[data-v-7a51a62f]{top:100px}.top--50[data-v-7a51a62f]{top:50px}.content-container[data-v-7a51a62f]{max-width:1904px!important;padding:0}", ""]);
// Exports
module.exports = exports;
